import logo from './logo.svg';
import './App.css';
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Steps from './components/Steps';
import Template1 from './components/Template1';
import Index from './components/Index';
import Contact from './components/contact';
import Navbar from './components/Navbar';
import Result from './components/Result';

function App() {
  return (
    <>
      <Navbar/>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/form" element={<Steps />} />
          <Route path='/template' element={<Template1 />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/result' element={<Result />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App;
